import { useEffect, useState } from "react";
import { IdCard, Loader2, Save, Pencil } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

const FIELDS = [
  ["nombre_completo", "Nombre completo"],
  ["puesto", "Puesto"],
  ["area", "Área / Departamento"],
  ["correo_empresa", "Correo de la empresa"],
  ["telefono", "Teléfono / Extensión"],
  ["anio_ingreso", "Año de ingreso"],
  ["nivel_estudios", "Nivel de estudios"],
  ["fecha_nacimiento", "Fecha de nacimiento"],
  ["jefe_directo", "Jefe directo"],
  ["ubicacion", "Ubicación / Sede"],
  ["cursos", "Cursos tomados"],
  ["habilidades", "Habilidades"],
];

export default function EmployeeProfileCard() {
  const { user } = useAuth();
  const [p, setP] = useState(null);
  const [edit, setEdit] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then((r) => {
      const prof = r.data.profile || {};
      setP({ nombre_completo: prof.nombre_completo || r.data.name || "", ...prof });
    }).catch(() => setP({}));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/auth/profile", { ...p, biografia: p.biografia || "" });
      toast.success("Ficha actualizada");
      setEdit(false);
    } catch (e) { toast.error("No se pudo guardar"); }
    finally { setSaving(false); }
  };

  if (!p) return null;
  const filled = FIELDS.filter(([k]) => p[k]).length;
  const pct = Math.round((filled / FIELDS.length) * 100);

  return (
    <div className="card-surface p-6" data-testid="employee-profile-card">
      <div className="flex items-center justify-between mb-4">
        <div className="overline text-navy/40 flex items-center gap-2"><IdCard className="w-3.5 h-3.5" /> Mi ficha de empleado · {pct}% completa</div>
        {!edit ? (
          <button onClick={() => setEdit(true)} data-testid="profile-edit" className="inline-flex items-center gap-1.5 text-sm text-violet hover:underline"><Pencil className="w-3.5 h-3.5" /> Editar</button>
        ) : (
          <button onClick={save} disabled={saving} data-testid="profile-save" className="btn btn-primary text-sm">{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Guardar</button>
        )}
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {FIELDS.map(([k, label]) => (
          <div key={k}>
            <label className="text-[11px] uppercase tracking-wide text-navy/40">{label}</label>
            {edit ? (
              <input data-testid={`profile-${k}`} value={p[k] || ""} onChange={(e) => setP({ ...p, [k]: e.target.value })}
                className="mt-1 w-full bg-white border border-navy/10 rounded-lg px-3 py-2 text-sm outline-none focus:border-violet" />
            ) : (
              <div className="mt-1 text-sm text-navy/75">{p[k] || <span className="text-navy/30">—</span>}</div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-4">
        <label className="text-[11px] uppercase tracking-wide text-navy/40">Biografía</label>
        {edit ? (
          <textarea data-testid="profile-biografia" rows={3} value={p.biografia || ""} onChange={(e) => setP({ ...p, biografia: e.target.value })}
            className="mt-1 w-full bg-white border border-navy/10 rounded-lg px-3 py-2 text-sm outline-none focus:border-violet" />
        ) : (
          <div className="mt-1 text-sm text-navy/75">{p.biografia || <span className="text-navy/30">—</span>}</div>
        )}
      </div>
    </div>
  );
}
